module.exports = __webpack_public_path__ + "img/jobGrade.e73d5cf4.svg";